module.exports = __webpack_public_path__ + "img/coqui.44d784a5.svg";